import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    // Unify brand gold to match the app's visual (Pitching Analytics) color
    custom: { gold: 'var(--color-gold)' },
  },
});

export default theme;
